<div
  *ngIf="viewport === 'mobile'; else Desktop"
  class="inpage-search"
  [ngClass]="{
    'inpage-search__flex-column': flexDirectionMobile === 'column',
  }"
>
  <hdi-search
    [ngClass]="{
      'cta-mode': CTA,
      'inpage-search-item': padding,
      'inpage-search-item-no-padding': !padding,
    }"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [inpage]="true"
    [inpageCTA]="CTA"
    (handleInputChange)="inputChange($event)"
    (handleClearInput)="closeSearchResults()"
  ></hdi-search>
  <hdi-button
    *ngIf="CTA"
    [label]="labelCTAMobile | capitalize"
    [type]="buttonTypeMobile"
    [iconName]="buttonIconMobile"
    [disabled]="buttonDisabled"
    [ngClass]="{
      'inpage-search__expand-button':
        expandButton && flexDirectionMobile === 'column',
    }"
    [expandButton]="expandButton && flexDirectionMobile === 'column'"
  ></hdi-button>
</div>
<ng-template #Desktop>
  <div
    class="inpage-search"
    [ngClass]="{
      'inpage-search__flex-column': flexDirection === 'column',
      'inpage-search--no-search-icon': CTA,
    }"
  >
    <hdi-search
      [ngClass]="{
        'cta-mode': CTA,
        'inpage-search-item': padding,
        'inpage-search-item-no-padding': !padding,
      }"
      [placeholder]="placeholder"
      [viewport]="viewport"
      [disabled]="disabled"
      [inpage]="true"
      [inpageCTA]="CTA"
      [hasError]="hasError"
      (handleInputChange)="inputChange($event)"
      (handleClearInput)="closeSearchResults()"
    ></hdi-search>
    <span *ngIf="hasError" class="inpage-search-error-message"
      >Bitte geben Sie mind. drei Zeichen ein.</span
    >
    <div class="inpage-search__auto-complete" *ngIf="!hasError && !isEmpty">
      <ul #resultContainer class="inpage-search__auto-complete-list">
        <span *ngIf="searchedElements.length === 0"
          >Keine Ergebnisse gefunden</span
        >
        <ng-container *ngIf="searchedElements.length > 0">
          <div
            class="inpage-search__auto-complete-list-category"
            *ngFor="let searchedGroup of searchedElements"
          >
            <h5 *ngIf="searchedGroup">{{ searchedGroup.headline }}</h5>
            <li
              (click)="findElement(searched.label); closeSearchResults()"
              *ngFor="let searched of searchedGroup.templates"
              [innerHTML]="searched.template"
            ></li>
          </div>
        </ng-container>
      </ul>
    </div>
    <hdi-button
      *ngIf="CTA"
      [label]="labelCTA | capitalize"
      [type]="buttonType"
      [iconName]="buttonIcon"
      [disabled]="buttonDisabled"
      [ngClass]="{
        'inpage-search__expand-button':
          expandButton && flexDirection === 'column',
      }"
      [expandButton]="expandButton && flexDirection === 'column'"
    ></hdi-button>
  </div>
</ng-template>
